<div class="card mt-4">
  <p-breadcrumb [model]="breadcrumbItems" [home]="breadcrumbHome"></p-breadcrumb>
</div>

<div class="card mt-4">
  <div class="w-full md:w-auto">
    <h3 class="font-semibold text-xl mb-2 text-center md:text-left">Liste des Rapports</h3>
  </div>


  <br><br>

    <div *ngIf="selectedRapport" >
      <h2 class="font-semibold text-xl mb-2 text-center">
        rapport sélectionné : {{ selectedRapport }}
      </h2>
    </div><br>

<div class="flex flex-wrap gap-6 mb-8 justify-center">

  <div *ngFor="let rapport of rapportItems"
       class="w-[320px] h-[160px] flex flex-col cursor-pointer transition-all duration-300 ease-in-out
              border border-gray-200 rounded-xl
              hover:border-primary-300 hover:shadow-lg group"
       [ngClass]="{'border-2 border-primary-500 shadow-md transform -translate-y-1': rapport.selected}"
       (click)="handleRapportClick(rapport)">

    <div class="flex flex-1 flex-col items-center justify-center p-4 text-center">

      <div class="p-3 rounded-xl mb-3 bg-gradient-to-br"
           [style.backgroundColor]="rapport.color + '20'">
        <i [class]="rapport.icon"
           [style.color]="rapport.color"
           class="text-2xl drop-shadow-sm"></i>
      </div>

      <div>
        <h3 class="font-semibold text-sm mb-1 transition-colors">
          {{ rapport.name }}
        </h3>
        <p class="text-sm text-gray-500 group-hover:text-gray-600 transition-colors">
          Cliquez pour configurer
        </p>
      </div>

      <div *ngIf="rapport.selected" class="mt-3">
        <span class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-800">
          <i class="pi pi-check-circle mr-1 text-xs"></i>
          Sélectionné
        </span>
      </div>

    </div>

  </div>

</div>



<div *ngIf="showFilters" class="flex flex-col items-center px-4">

  <div class="w-full text-center mb-6">
    <h3 class="font-semibold text-xl">Options des filtrages</h3>
  </div>

  <div *ngIf="selectedDo !== 'all' || selectedAgent !== 'all' || selectedQueue !== 'all'" class="mt-2 text-center mb-6">
    <h3 class="font-semibold text-xs">
      <span *ngIf="selectedDo !== 'all'">DO: {{ selectedDo }}</span>
      <span *ngIf="selectedAgent !== 'all'"> | Agent: {{ selectedAgent }}</span>
      <span *ngIf="selectedQueue !== 'all'"> | File d'attente: {{ selectedQueue }}</span>
    </h3>
  </div>

  <div class="w-full max-w-3xl space-y-4 mb-6">
    <div class="filter-card border border-gray-300 rounded-lg p-4  shadow-sm" *ngIf="INTERACTION_DOSSIER_REPORTS.includes(selectedRapport || '')">
      <label class="block text-sm font-medium text-gray-700 mb-2">
        Sélectionnez un DO
        <i *ngIf="loadingDo" class="pi pi-spinner pi-spin ml-2 text-sm"></i>
      </label>
      <p-dropdown
        [options]="filteredDoList"
        [(ngModel)]="selectedDo"
        [filter]="true"
        (onChange)="onDoChange()"
        filterPlaceholder="Rechercher un DO..."
        placeholder="Sélectionner un DO"
        [style]="{'width':'100%', 'height': '42px'}"
        inputStyleClass="text-base py-3 px-3"
        >
        <ng-template let-option pTemplate="item">
          <div class="flex items-center text-sm p-2">
            <i class="pi pi-tag mr-2 text-xs"></i>
            <span>{{ option }}</span>
          </div>
        </ng-template>
      </p-dropdown>
    </div>

    <!-- Filtre Agent -->
    <div class="filter-card border border-gray-300 rounded-lg p-4  shadow-sm" *ngIf="AGENT_REPORTS.includes(selectedRapport || '')">
      <label class="block text-sm font-medium text-gray-700 mb-2">
        Sélectionnez un agent
        <i *ngIf="loadingAgents" class="pi pi-spinner pi-spin ml-2 text-sm"></i>
      </label>
      <p-dropdown
        [options]="filteredAgentList"
        [(ngModel)]="selectedAgent"
        [filter]="true"
        (onChange)="onAgentChange()"
        filterPlaceholder="Rechercher un agent..."
        placeholder="Sélectionner un agent"
        [style]="{'width':'100%', 'height': '42px'}"
        inputStyleClass="text-base py-3 px-3"
        >
        <ng-template let-option pTemplate="item">
          <div class="flex items-center text-sm p-2 ">
            <i class="pi pi-tag mr-2 text-xs"></i>
            <span>{{ option }}</span>
          </div>
        </ng-template>
      </p-dropdown>
    </div>

    <!-- Filtre Queue -->
    <div class="filter-card border border-gray-300 rounded-lg p-4  shadow-sm" *ngIf="selectedRapport && !INTERACTION_DOSSIER_REPORTS.includes(selectedRapport) && !AGENT_REPORTS.includes(selectedRapport)">
      <label class="block text-sm font-medium text-gray-700 mb-2">
        Sélectionnez une queue
        <i *ngIf="loadingQueues" class="pi pi-spinner pi-spin ml-2 text-sm"></i>
      </label>
      <p-dropdown
        [options]="filteredQueueList"
        [(ngModel)]="selectedQueue"
        [filter]="true"
        (onChange)="onQueueChange()"
        filterPlaceholder="Rechercher une queue..."
        placeholder="Sélectionner une queue"
        [style]="{'width':'100%', 'height': '42px'}"
        inputStyleClass="text-base py-3 px-3"
      >
        <ng-template let-option pTemplate="item">
          <div class="flex items-center text-sm p-2 ">
            <i class="pi pi-tag mr-2 text-xs"></i>
            <span>{{ option }}</span>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
  </div>

  <div class="w-full text-center mb-4">
    <h3 class="font-semibold text-xl">Période des données</h3>
  </div>

  <div class="w-full max-w-3xl">
    <div class="flex flex-col md:flex-row gap-4">
      <div class="filter-card border border-gray-300 rounded-lg p-4  shadow-sm w-full">
        <label class="font-semibold text-sm mb-2 flex items-center">
          <i class="pi pi-calendar mr-2"></i> Date de début
        </label>
        <p-datepicker
          [(ngModel)]="startDate"
          [showIcon]="true"
          [maxDate]="endDate || maxDate"
          [minDate]="minDate"
          dateFormat="dd/mm/yy"
          [showButtonBar]="true"
          [readonlyInput]="true"
          placeholder="Sélectionnez une date"
           [styleClass]="'w-full'">
        </p-datepicker>
      </div>

      <div class="filter-card border border-gray-300 rounded-lg p-4  shadow-sm w-full">
        <label class="font-semibold text-sm mb-2 flex items-center">
          <i class="pi pi-calendar mr-2"></i> Date de fin
        </label>
        <p-datepicker
          [(ngModel)]="endDate"
          [showIcon]="true"
          [maxDate]="maxDate"
          [minDate]="startDate || minDate"
          dateFormat="dd/mm/yy"
          [showButtonBar]="true"
          [readonlyInput]="true"
          placeholder="Sélectionnez une date"
           [styleClass]="'w-full'">
        </p-datepicker>
      </div>
    </div>
  </div>

  <div *ngIf="startDate && endDate && !validateDates()" class="text-red-500 text-sm mb-4 text-center mt-2">
    <i class="pi pi-exclamation-triangle mr-2"></i>
    La date de fin doit être supérieure ou égale à la date de début et antérieure à aujourd'hui.
  </div>

  <div class="flex justify-center mt-6 mb-4 w-full">
    <p-button
      label="Preview"
      icon="pi pi-eye"
      [disabled]="!canExport() || exporting || loadingPreview"
      (click)="showPreview()" class="p-button-secondary">
 </p-button>
  </div>
</div>
<p-toast position="top-right"></p-toast>

<p-dialog header="Aperçu du rapport" [(visible)]="previewVisible"
          [style]="{width: '90vw'}" [modal]="true"
          [resizable]="true" [draggable]="true"
          [closable]="true" [dismissableMask]="true"
          [maximizable]="true">

  <div *ngIf="loadingPreview" class="flex justify-center items-center p-8">
    <p-progressSpinner styleClass="w-8 h-8" strokeWidth="4"></p-progressSpinner>
    <span class="ml-2">Chargement des données...</span>
  </div>

  <div *ngIf="!loadingPreview">
    <div *ngIf="previewData.length === 0" >
      <div class="flex items-center">
        <div class="flex-shrink-0 pt-0.5">
          <i class="pi pi-info-circle text-blue-400 text-xl"></i>
        </div>
        <div class="ml-3">
          <h3 class="text-sm font-medium ">Aucune donnée disponible</h3>
          <div class="mt-1 text-sm text-blue-700">
            <p>
              Les critères de recherche ne retournent aucune donnée. Veuillez essayer avec d'autres filtres ou une autre période.
            </p>
          </div>
        </div>
      </div>
    </div>
    <p-table *ngIf="previewData.length > 0" [value]="previewData"
             [columns]="previewColumns"
             [paginator]="true" [rows]="10"
             [loading]="false"
             [resizableColumns]="true"
             [scrollable]="true" scrollHeight="60vh">

      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col *ngFor="let col of columns" />
        </colgroup>
      </ng-template>

      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns">{{ col.header }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row let-columns="columns">
        <tr>
          <td *ngFor="let col of columns">{{ row[col.field] }}</td>
        </tr>
      </ng-template>
    </p-table>

    <div class="flex justify-end gap-3 mt-4">
      <p-button label="Exporter"
                icon="pi pi-download"
                [disabled]="!canExport() || exporting || previewData.length === 0"
                (click)="startExport()"
                [loading]="exporting">
      </p-button>
    </div>

    <div *ngIf="exporting" class="w-full px-12 mt-4">
      <p-progressBar [value]="progressValue"
                     [showValue]="false"
                     mode="determinate">
      </p-progressBar>

      <div class="flex justify-between mt-2 text-sm">
        <span>{{ progressValue }}% complété</span>
        <span *ngIf="progressValue === 100" class="text-green-500">
          <i class="pi pi-check mr-1"></i>Prêt pour le téléchargement
        </span>
      </div>
    </div>
  </div>
</p-dialog>
